export interface FeaturedProject {
  id: "kyofuse" | "skillnapse";
  liveUrl?: string;
  backendUrl?: string;
  repoUrl?: string;
  previewImage: string;
  isPrivate?: boolean;
  stack: string[];
}

export const featuredProjects: FeaturedProject[] = [
  {
    id: "kyofuse",
    liveUrl: "https://kyofuse.com",
    previewImage: "/projects/kyofuse/feed.png",
    isPrivate: true,
    stack: [
      "Java",
      "Spring Boot",
      "Angular",
      "TypeScript",
      "PostgreSQL",
      "Redis",
      "WebSocket",
      "Tailwind CSS",
      "Docker",
    ],
  },
  {
    id: "skillnapse",
    liveUrl: "https://skillnapse.me",
    backendUrl: "https://github.com/Hosz/SkillNapse-API",
    previewImage: "/projects/skillnapse/preview.png",
    stack: [
      "Java",
      "Spring Boot",
      "Spring AI",
      "Google Gemini",
      "Groq",
      "PostgreSQL",
      "Docker",
      "JWT",
      "React",
    ],
  },
];

export const kyofuse = featuredProjects[0];

export interface SecondaryProject {
  id:
    | "laylayStore"
    | "pocketmarket"
    | "caseAutou"
    | "mobileTicketApi"
    | "linkManagerApi"
    | "ecommerceAiAgent"
    | "woaRpg"
    | "meLevaAi"
    | "gamex"
    | "oldflix";
  repoUrl?: string;
  backendUrl?: string;
  frontendUrl?: string;
  liveUrl?: string;
  stack: string[];
}

/** Sourced from github.com/Hosz and the PocketMarket project report. */
export const secondaryProjects: SecondaryProject[] = [
  {
    id: "laylayStore",
    liveUrl: "https://laylay-store.vercel.app",
    stack: ["React", "TypeScript", "Vite", "Tailwind CSS", "Supabase"],
  },
  {
    id: "pocketmarket",
    backendUrl: "https://github.com/ViniciusS4ntos/PocketMarket",
    frontendUrl: "https://github.com/adry4nbr/PocketMarket-Frontend",
    stack: ["Java", "Spring Boot", "PostgreSQL", "React", "Docker"],
  },
  {
    id: "caseAutou",
    repoUrl: "https://github.com/Hosz/case_autou",
    stack: ["Python", "Flask", "Gemini API", "JavaScript"],
  },
  {
    id: "mobileTicketApi",
    repoUrl: "https://github.com/Hosz/mobile-ticket-api",
    stack: ["Node.js", "Express", "Sequelize", "MySQL"],
  },
  {
    id: "linkManagerApi",
    repoUrl: "https://github.com/Hosz/link_manager_api",
    stack: ["Python", "Flask", "PostgreSQL", "Docker"],
  },
  // CWI Software — TCC / group projects from the CWI Crescer training program.
  // Repos live on an internal GitLab instance (git.cwi.com.br), so no public link is rendered.
  {
    id: "ecommerceAiAgent",
    stack: ["Java", "Spring Boot", "JMS", "MCP", "Angular", "Docker", "Kubernetes", "Helm"],
  },
  {
    id: "woaRpg",
    stack: ["Angular", "TypeScript", "RxJS", "JWT"],
  },
  {
    id: "meLevaAi",
    stack: ["Java", "Spring Boot", "PostgreSQL", "Angular", "Swagger"],
  },
  // Solo exercises from the same CWI Crescer personal training repo.
  {
    id: "gamex",
    stack: ["Java", "Spring Boot", "Spring Security", "PostgreSQL", "Angular", "JWT"],
  },
  {
    id: "oldflix",
    stack: ["Java", "Spring Boot", "PostgreSQL", "Angular", "Docker"],
  },
];
